// extracted by mini-css-extract-plugin
module.exports = {"Right":"Participants_Right__QJH3Z","Filters":"Participants_Filters__pKn8F"};